<script>
import axios from "axios";
import ImportStudents from "./import-students.vue";
import VyukaForm from "@/components/ll/vyuka-form.vue";
import LessonInstance from "@/components/ll/lesson-instance.vue";
import AdminCreditHistoryModal from "./admin-credit-history-modal.vue";

export default {
  name: "my_students",
  props: ['btyp'],
  components: {LessonInstance, VyukaForm, ImportStudents, AdminCreditHistoryModal },
  data() {
    return {
      lessons: [],
      companies:[],
      current_lesson: null,
      lector_options: [],
      selectedCompany: null,
      selectedLector: null,
      selectedTypeLesson: null,
      credit_range: '',
      searchQuery: '',
      searchDebounceTimer: null
    };
  },
  mounted() {
    this.loadStudents();
  },
  methods: {
    handleEditLesson(lesson) {
        this.current_lesson = lesson;
        // Předpokládáme, že máte komponentu pro úpravu lekce
        // Můžete zde otevřít modální okno nebo přesměrovat
      this.$refs.formVyuka.showModal();

    },
    handleNewLessonInstance(lesson) {
      this.current_lesson = lesson;
      // Předpokládáme, že máte komponentu pro vytvoření nové instance lekce
      // Můžete zde otevřít modální okno nebo přesměrovat
      this.$refs.formLessonInstance.showModal();

    },


    loadStudents() {
      const url = '/ll/students/lessons.json';
      axios.get(url, {
        params: {
          btyp: this.btyp,
          company_id: this.selectedCompany,
          lector_id: this.selectedLector,
          lesson_type: this.selectedTypeLesson,
          credit_range: this.credit_range,
          search_query: this.searchQuery
        }
      })
          .then(response => {
            this.lessons = response.data.lessons;
            this.companies = response.data.companies;
            this.lector_options = response.data.lectors;
          })
          .catch(error => {
            console.error('Došlo k chybě při načítání lekcí:', error);
          });
    },
    handleSearchInput() {
      clearTimeout(this.searchDebounceTimer);
      this.searchDebounceTimer = setTimeout(() => {
        this.loadStudents();
      }, 500);
    },
    handleImportSuccess() {
      this.loadStudents();
    },
    showImportModal() {
      this.$refs.importStudentsComponent.showModal();
    },
    addVyuka() {
      this.current_lesson = {
        students: [],
        lector: null,
        lesson_type: 'one_to_one',
        language_level: '',
        preferred_time: '',
        minutes: 0,
        lessons_per_month: 0,
        credit: 0,
        change_credit:0
      };
      this.$refs.formVyuka.showModal();
    },
    handleSaveLesson(lesson) {
      this.loadStudents();
    },
    showCreditHistory(lesson) {
      this.$refs.creditHistoryModal.open(lesson.id);
    }
  }
}
</script>

<template>
  <div>
    {{btyp}}

    <div class="d-flex justify-content-end mb-3">

      <button type="button" class="btn btn-primary" @click="showImportModal" v-if="btyp=='b2b'">
        Importovat studenty
      </button>


      <button type="button" class="btn btn-primary" @click="addVyuka">
       Přidat výuku
      </button>

    </div>

    <import-students ref="importStudentsComponent" @import-successful="handleImportSuccess"></import-students>

  </div>

  <div class=" card card-body  mt-2">
    <div class="row">
      <div class="col-md-3" >
        <label>Vyhledat studenta (e-mail nebo jméno)</label>
        <input
          type="text"
          class="form-control"
          v-model="searchQuery"
          @input="handleSearchInput"
          placeholder="Zadejte e-mail nebo jméno studenta"
        >
      </div>

      <div class="col-md-3" v-if="btyp==='b2b'">
        <label>Společnost</label>
        <select v-model="selectedCompany" class="form-control" @change="loadStudents">
          <option value="">-- Vyberte společnost --</option>
          <option v-for="company in companies" :key="company.id" :value="company.id">
            {{ company.name }}
          </option>
        </select>



      </div>

      <div class="col-md-3">
        <label>Lektor</label>
        <select v-model="selectedLector" class="form-control" @change="loadStudents">
          <option value="">-- Vyberte lektora --</option>
          <option v-for="lector in lector_options" :key="lector.id" :value="lector.id">
            {{ lector.first_name }} {{ lector.last_name }}
          </option>

        </select>

      </div>
      <div class="col-md-3" v-if="btyp==='b2b'">
        <label>Typ lekce</label>
        <select class="form-control" @change="loadStudents" v-model="selectedTypeLesson">
          <option></option>
          <option value="one_to_one">jeden na jednoho</option>
          <option value="two_students"> párová lekce</option>
          <option value="group">skupinová lekce</option>

        </select>

      </div>

      <div class="col-md-3" v-if="btyp==='b2c'">
        <label>Kredit</label>
        <select v-model="credit_range" @change="loadStudents" class="form-control">
          <option value="">Všechny</option>
          <option value="less_than_4">Méně než 4 lekce</option>
          <option value="more_than_4">Více než 4 lekce</option>
          <option value="no_credit">Žádný kredit</option>
        </select>
      </div>

    </div>








    <table class="table table-bordered">

      <thead>
      <tr>
        <th>Studenti</th>
        <th>Lektor</th>
        <th>Typ lekce</th>
        <th>Jazyková úroveň</th>
        <th>Preferovaný čas</th>
        <th>Minutáž</th>
        <th>Lekcí za měsíc</th>
        <th>Kredit</th>
        <th>Akce</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="lesson in lessons" :key="lesson.id">
        <td>
          <ul class="list-unstyled mb-0">
            <li v-for="student in lesson.students" :key="student.id">
              <i>{{ student.email }}</i> <a :href="`/students/${student.id}`" target="_blank">{{student.name}} {{student.surname}}</a>
            </li>
          </ul>
        </td>
        <td>{{ lesson.lector ? [lesson.lector.first_name, lesson.lector.last_name].join(' ')  : 'N/A' }}</td>
        <td>{{ lesson.lesson_type_name }}</td>
        <td>{{ lesson.language_level }}</td>
        <td>{{ lesson.preferred_time_name }}</td>
        <td>{{ lesson.minutes }}</td>
        <td>{{ lesson.lessons_per_month }}</td>
        <td>
          {{lesson.instances_count}} /
          <a href="#" 
             @click.prevent="showCreditHistory(lesson)" 
             class="credit-link"
             title="Zobrazit historii kreditů">
            {{lesson.credit}}
          </a>
        </td>
        <td>
          <a href="#" @click.prevent="handleEditLesson(lesson)">upravit</a>
        </td>
        <td>
          <a href="#" @click.prevent="handleNewLessonInstance(lesson)">New lesson </a>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <vyuka-form :lesson="current_lesson" :btyp="btyp"  ref="formVyuka" @save-lesson="handleSaveLesson"></vyuka-form>

 <lesson-instance :lesson="current_lesson" ref="formLessonInstance"></lesson-instance>

 <admin-credit-history-modal ref="creditHistoryModal" />

</template>

<style scoped>
.credit-link {
  color: #007bff;
  text-decoration: none;
  cursor: pointer;
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 3px;
  transition: all 0.2s ease;
}

.credit-link:hover {
  color: #0056b3;
  background-color: #e7f3ff;
  text-decoration: underline;
}
</style>